export default __webpack_public_path__ + "static/media/hubspot-logo.0cd0dcf5.svg";